<template>
  <pt-propmotion-detail class="pt-propmotion-detail__withData" :promotion-detail="promotionDetail" :loading="loading"></pt-propmotion-detail>
</template>

<script>
import PtPropmotionDetail from './index'
export default {
  name: 'pt-propmotion-detail__withData',
  components: {
    'pt-propmotion-detail': PtPropmotionDetail
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      promotionDetail: {},
      loading: false
    }
  },
  methods: {
    getPromotionDetail () {
      this.loading = true
      this.$store.dispatch('promotionDetail', this.id).then(res => {
        this.promotionDetail = res
        this.loading = false
      }).catch(err => {
        this.loading = false
        this.$message.error(err || '获取优惠劵详情失败')
      })
    }
  },
  created () {
    this.getPromotionDetail()
  }
}
</script>
